import React from 'react';
import { faqData } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="section-padding bg-gradient-to-b from-gray-900 to-black relative">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Title */}
          <div className="text-center mb-10 md:mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4">
              Dúvidas <span className="gradient-text">Frequentes</span>
            </h2>
            <p className="text-base md:text-xl text-gray-400">
              Tire suas dúvidas antes de se inscrever
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion type="single" collapsible className="space-y-3 md:space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem
                key={faq.question}
                value={`item-${index}`}
                className="glass rounded-lg border-none px-4 md:px-6"
              >
                <AccordionTrigger className="text-left text-white hover:text-yellow-400 transition-colors duration-300 py-4 md:py-5">
                  <span className="font-semibold text-base md:text-lg">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 text-sm md:text-base leading-relaxed pb-4 md:pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Bottom CTA */}
          <div className="mt-10 md:mt-12 text-center glass-dark p-5 md:p-8 rounded-2xl">
            <p className="text-gray-300 text-base md:text-lg mb-4">
              Pronto para dominar a Console WING?
            </p>
            <a
              href="#inscricao"
              className="inline-block w-full sm:w-auto bg-yellow-500 hover:bg-yellow-600 text-black px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold transition-all duration-300 hover:scale-105 glow-yellow"
            >
              GARANTIR MINHA VAGA
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
